<!-- Color Light-Blue  #1a6fb0 -->
<template>
  <div class="bg-secondary">
    <navbar />
    <main class="" style="padding-top: 0rem;">
      <section class="mx-auto" style="max-width: 1400px">
        <div class="px-0 px-xl-5">
          <evalHero />
          <howItWorks v-if="evalManager.evalComplete !== true" class="border"/>          
          <whyUs class="my-5"/> 
          <faq />
          <newsletter />
          <div class="pb-4"></div>
        </div>
      </section>
      <myFooter />
    </main>
  </div>
</template>


<script>
import { mapGetters } from 'vuex';
import Vue from "vue"
import navbar from '@/components/navbar.vue'
import evalHero from './components/evalHero.vue'
import newsletter from '@/views/home/components/newsletter.vue'
import whyUs from '@/views/home/components/whyUs.vue'
import faq from '@/components/faq.vue'
import howItWorks from '@/views/home/components/howitworks.vue'
import myFooter from '@/components/footer.vue'

export default {
  name: 'Evaluation',
  components: {
    myFooter,
    howItWorks,
    whyUs,
    navbar,
    faq,
    evalHero,
    newsletter
  },
  data: () => ({
  }),
  computed: {
    ...mapGetters(['evalManager', 'evalManagerError']),
  },
  created: function () {
  },
  mounted: function () {
    Vue.nextTick(() => {
      this.loadBootstrapTheme();
    });
  },
  methods: {
    loadBootstrapTheme: function () {
      let theme = document.createElement('script')
      theme.setAttribute('src', 'theme.js')
      document.head.appendChild(theme) 
    },
  }
}
</script>
